import { Button, Card, CardBody, Col, Container, Row } from "reactstrap"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { paymentSuccess } from "../../../redux/actions/user"
import React from "react"

const PaymentGateway = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const stepFormData = useSelector(state => state.user.stepFormData)
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="mb-3"></div>
        <Container fluid={true}>
          <Card className="border-0 shadow-sm">
            <CardBody>
              <h3>Payment Gateway</h3>
              <Row>
                <Col md={6}>
                  <Button
                    type="submit"
                    color="success"
                    size="md"
                    onClick={() => {
                      dispatch(paymentSuccess(stepFormData, "")),
                        navigate("/user-dashboard")
                    }}
                  >
                    Success
                  </Button>
                  <Button
                    type="submit"
                    color="danger"
                    size="md"
                    onClick={() => navigate(-1)}
                  >
                    Failure
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PaymentGateway
